import { AuthUser } from "@/types/firebase";

export const isLoggedInCheck = (authUser: any) => !!authUser;

export const getSignInProviderFromToken = (
  accessToken: string
): string | null => {
  try {
    const base64Url = accessToken.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload).firebase["sign_in_provider"] ?? null;
  } catch {
    return null;
  }
};

const isSsoProviderId = (providerId: string) =>
  providerId.startsWith("saml.") || providerId.startsWith("oidc.");

export const isSsoUser = (user: AuthUser | null | undefined): boolean => {
  if (!user) return false;

  const signInProvider = user.accessToken
    ? getSignInProviderFromToken(user.accessToken)
    : null;
  if (signInProvider && isSsoProviderId(signInProvider)) {
    return true;
  }

  return false;
};

/**
 *
 * @param {string} email
 * @returns {string}
 */
export const normalizeEmailForCompare = (email: string) =>
  email.trim().toLowerCase();

export const getEmailDomain = (email: string) => {
  if (!email) return "";
  return email.split("@")[1] ? email.split("@")[1] : "";
};

export const isCorporate = (email: string) => {
  if (email) {
    const domain = email.substring(email.indexOf("@") + 1);
    const domainSegment = domain && domain.substring(0, domain.indexOf("."));
    if (
      ![
        "gmail",
        "yahoo",
        "hotmail",
        "aol",
        "outlook",
        "msn",
        "icloud",
        "protonmail",
        "me",
        "mac",
        "live",
        "yandex",
        "tutanota",
        "web",
        "btinternet",
        "ymail",
        "mail",
        "murf",
        "googlemail",
        "qq"
      ].includes(domainSegment)
    ) {
      return domain;
    }
  }
  return undefined;
};

export const getQueryParams = () => {
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const queryObject: Record<string, string> = {};

  params.forEach((value, key) => {
    queryObject[key] = value;
  });

  return queryObject;
};
